import { Component, computed, input } from "@angular/core";
import { IEpisode } from "@project/models/episodes/episode";
import { EpisodeStatus } from "@project/models/episodes/episode-status";
import { isNoteDraftEpisode } from "./episode-select/episode-defaults";

@Component({
    selector: "episode-header-title",
    template: `
        <div class="header-title-container">
            <p-tag *ngIf="isLocal$$()" severity="warning" [rounded]="true">
                <span class="p-tag-icon pi pi-exclamation-triangle mr-1"></span>
                <span class="p-tag-value">OFFLINE</span>
            </p-tag>
            @if (isDocumentsUploaded$$()) {
                <div class="header-title">
                    <i class="pi pi-bookmark mr-2"></i>
                    <div class="diagnose-title">Patient Uploaded Documents</div>
                </div>
            } @else {
                <div class="header-title" [ngClass]="{ 'is-archived': isArchived$$() }" *ngFor="let diagnose of diagnoses$$()">
                    <div class="diagnose-title">
                        {{ diagnose.diagnosisName }}
                    </div>
                    <div style="font-size: 14px; display: inline-block;">
                        <div class="dash-marker" *ngIf="hasAdditionalInfo(diagnose)">
                            <i class="pi pi-minus ml-1 mr-1 fs-red"></i>
                        </div>
                        <div class="diagnose-cont">
                            <ng-container
                                *ngIf="
                                    diagnose.diagnosisBodyPartName !== 'N/A' &&
                                    diagnose.diagnosisBodyPartName !== '' &&
                                    diagnose.id !== null
                                ">
                                {{ diagnose.diagnosisBodyPartName }}
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    diagnose.diagnosisBodyPartName !== 'N/A' &&
                                    diagnose.diagnosisBodyPartName !== '' &&
                                    diagnose.bodySide !== 'N/A' &&
                                    diagnose.bodySide !== '' &&
                                    diagnose.id !== null
                                ">
                                <span class="mip-divider"> | </span>
                            </ng-container>

                            <ng-container *ngIf="diagnose.bodySide !== 'N/A' && diagnose.bodySide !== '' && diagnose.id !== null">
                                {{ diagnose.bodySide }}
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    ((diagnose.bodySide !== 'N/A' && diagnose.bodySide !== '') ||
                                        (diagnose.diagnosisBodyPartName !== 'N/A' && diagnose.diagnosisBodyPartName !== '')) &&
                                    diagnose.diagnosisMedicalSystemName &&
                                    diagnose.diagnosisMedicalSystemName !== 'N/A' &&
                                    diagnose.diagnosisMedicalSystemName !== '' &&
                                    diagnose.id !== null
                                ">
                                <span class="mip-divider"> | </span>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    diagnose.diagnosisMedicalSystemName &&
                                    diagnose.diagnosisMedicalSystemName !== 'N/A' &&
                                    diagnose.diagnosisMedicalSystemName !== '' &&
                                    diagnose.id !== null
                                ">
                                {{ diagnose.diagnosisMedicalSystemName }}
                            </ng-container>
                        </div>
                        <div class="badge-cont">
                            <ng-container *ngIf="isLocal$$() || isDraft$$() || isNoteDraft$$()">
                                <span class="badge draft-badge">Draft</span>
                            </ng-container>
                            <ng-container *ngIf="isWalkinDraft$$()">
                                <span class="badge walk-in-badge">Walk-In Draft</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            }
        </div>
    `,
    styleUrls: ["./episode-header-title.component.scss"]
})
export class EpisodeHeaderTitleComponent {
    episode$$ = input.required<IEpisode>({ alias: "episode" });

    protected diagnoses$$ = computed(() => this.episode$$().diagnoses);
    protected isLocal$$ = computed(() => this.episode$$().state == EpisodeStatus.StoredLocal);
    protected isArchived$$ = computed(() => this.episode$$().state === EpisodeStatus.Archived);
    protected isDraft$$ = computed(
        () => this.episode$$().state == EpisodeStatus.Draft || this.episode$$().state == EpisodeStatus.DraftPrescription
    );
    protected isWalkinDraft$$ = computed(() => this.episode$$().state == EpisodeStatus.WalkInDraft);
    protected isNoteDraft$$ = computed(() => isNoteDraftEpisode(this.episode$$()));
    protected isDocumentsUploaded$$ = computed(() => this.episode$$().state == EpisodeStatus.PatientUploadedDocuments);

    hasAdditionalInfo(diagnose: any): boolean {
        if (!diagnose || diagnose.id === null) {
            return false;
        }

        return (
            (diagnose.bodySide && diagnose.bodySide !== "N/A") ||
            (diagnose.diagnosisBodyPartName && diagnose.diagnosisBodyPartName !== "N/A") ||
            (diagnose.diagnosisMedicalSystemName && diagnose.diagnosisMedicalSystemName !== "N/A")
        );
    }
}
